<mat-toolbar>
  <h1>Projects</h1>
  <span class="spacer"></span>
  <div class="cell-actions">
    @if (auth.isAdminOrEditor()) {
      <button matMiniFab (click)="edit()" matTooltip="Add project">
        <mat-icon>add</mat-icon>
      </button>
    }
    @if (ownerType() === 'opportunity' && auth.isAdminOrEditor()) {
      <button matMiniFab (click)="addMilestone()" matTooltip="Add milestone">
        <mat-icon>flag</mat-icon>
      </button>
    }
    @if (auth.isAdminOrEditor()) {
      <button matMiniFab (click)="addPurchasedHours()" matTooltip="Add purchased hours">
        <mat-icon>schedule</mat-icon>
      </button>
    }
    <button matIconButton [disabled]="pending()" [class.rotating]="pending()" (click)="reload()">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>
</mat-toolbar>

<table mat-table matSort [dataSource]="source()" [trackBy]="trackBy" multiTemplateDataRows>
  <ng-container matColumnDef="Title">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Title</th>
    <td mat-cell *matCellDef="let item">{{ item.Title }}</td>
  </ng-container>

  <ng-container matColumnDef="Description">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Description</th>
    <td mat-cell *matCellDef="let item">{{ item.Description }}</td>
  </ng-container>

  <ng-container matColumnDef="_Type">
    <th mat-header-cell *matHeaderCellDef>Type</th>
    <td mat-cell *matCellDef="let item">{{ item._Type }}</td>
  </ng-container>

  <ng-container matColumnDef="PurchaseOrder">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Purchase Order</th>
    <td mat-cell *matCellDef="let item">{{ item.PurchaseOrder }}</td>
  </ng-container>

  <ng-container matColumnDef="StartDate">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Start Date</th>
    <td mat-cell *matCellDef="let item">{{ item.StartDate | date: 'dd/MM/y' }}</td>
  </ng-container>

  <ng-container matColumnDef="EndDate">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>End Date</th>
    <td mat-cell *matCellDef="let item">{{ item.EndDate | date: 'dd/MM/y' }}</td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell mat-sort-header *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let item">
      <div class="cell-actions">
        <mat-icon> {{ expandedRows()[item.Id] ? 'unfold_less' : 'unfold_more' }} </mat-icon>
        @if (item.Id && auth.isAdminOrEditor()) {
          <button matMiniFab (click)="edit(item)">
            <mat-icon>edit</mat-icon>
          </button>
        }
        @if (item.Id && auth.isAdmin()) {
          <button matMiniFab (click)="remove(item)">
            <mat-icon>delete</mat-icon>
          </button>
        }
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="invoices">
    <td
      mat-cell
      *matCellDef="let item"
      style="padding: 1rem"
      [attr.colspan]="columnsToShow().length"
      class="mat-bg-primary-container"
    >
      <div class="entity-form">
        @if (item.Milestones.length) {
          <lcm-milestone-table
            [source]="item.Milestones || []"
            [ownerId]="projectOwner()"
            [projects]="projectsForMilestones()"
            (removed)="updated.emit()"
            (saved)="updated.emit()"
          />
        }
        @if (item.PurchasedHours.length) {
          <lcm-purchased-hours-table
            [source]="item.PurchasedHours"
            [ownerType]="ownerType() === 'agreement' ? 'agreement' : 'product'"
            [ownerId]="projectOwner()"
            [projects]="projectsForPurchasedHours()"
            (removed)="updated.emit()"
            (saved)="updated.emit()"
          />
        }
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columnsToShow()"></tr>
  <tr mat-row *matRowDef="let row; columns: columnsToShow()" (click)="expandRow(row.Id)" style="cursor: pointer"></tr>
  <tr mat-row *matRowDef="let row; columns: ['invoices']" [hidden]="!expandedRows()[row.Id]"></tr>
</table>
